/* eslint-disable import/no-extraneous-dependencies */
import * as React from 'react';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from '@mui/lab';
import moment from 'moment';
import { Typography } from '@mui/material';
import { Activity } from '../../types';

function Activities(props: any) {
  const { activities } = props;
  const getTimelineItems = activities?.map((eachActivity: Activity) => {
    const date = moment(eachActivity.updatedDate).format('DD/MM/YYYY');
    const time = moment(eachActivity.updatedDate).format('hh:mm A');
    return (
      <TimelineItem>
        <TimelineOppositeContent color="text.secondary" sx={{ flex: 2 }}>
          {`${date} ${time}`}
        </TimelineOppositeContent>
        <TimelineSeparator sx={{ flex: 0.1 }}>
          <TimelineDot color="primary" />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent
          sx={{
            flex: 5,
            display: 'flex',
            flexWrap: 'wrap',
            wordBreak: 'break-word',
          }}
        >
          <div className="w-[100%] overflow-wrap flex flex-col gap-0 relative">
            {/* <EditorInline
              value={eachActivity?.activity || ''}
              disabled
            /> */}
            <span dangerouslySetInnerHTML={{ __html: eachActivity?.activity || '' }} />
            {eachActivity.updatedByName && (
            <Typography>
              {eachActivity.updatedByName}
            </Typography>
            )}

          </div>
        </TimelineContent>
      </TimelineItem>
    );
  });

  return (
    <Timeline>
      <div className="mb-4 text-lg underline text-secondary">Activities:</div>
      {getTimelineItems}
    </Timeline>
  );
}

export default Activities;
